// Jquery equal heights
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

    // Set Equal heights
  	var equalHeightsFunction = setTimeout(function() {
  		$(".puff-wrp").each(function(){
  			$(this).find('.equal').equalHeights();
  		});
  	}, 200);

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

    // Get Equal heights
  	$(".puff-wrp").each(function(){
  		$(this).find('.equal').height('auto');
  		$(this).find('.equal').equalHeights();
  	});


	});

})(jQuery);
